<template>
  <div :class="`prize-banner h-full flex flex-col justify-center prize-banner-${variant}`">
    <h2 class="headline paragraph-small-text text-secondary-secondary">
      {{ $t('highfrequencygame.prizebanner.headline') }}
    </h2>

    <h3 class="prize">{{ formatPrizeMoney(visibleJackpot) }}</h3>

    <slot />
  </div>
</template>

<script lang="ts" setup>
type Props = { variant?: 'banner' | 'modal' }

const { variant = 'modal' } = defineProps<Props>()
const { visibleJackpot } = useHighFrequencyGame()
const { formatPrizeMoney } = usePrizeMoneyFormatter()
</script>

<style lang="scss" scoped>
.prize-banner {
  position: relative;
  z-index: 0;
  overflow: hidden;

  .headline,
  .prize {
    z-index: 1;
  }

  .prize {
    height: auto;
    padding-left: 0.075rem;
    text-shadow:
      0 0.025rem token('color/yellow/800'),
      0 0.05rem token('color/yellow/700'),
      0 0.075rem token('color/yellow/600');
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    width: 23.438rem;
    background: radial-gradient(
      21.16% 152.97% at 15.08% 40.76%,
      token('color/background/accent/win/win-bold') 0%,
      rgb(255, 248, 181, 0%) 100%
    );
    pointer-events: none;
  }

  &-banner {
    gap: token('size/space/gap/025');
    background: token('color/background/accent/win/win')
      url('~/assets/img/highFrequencyGame/prize-banner-small.svg') no-repeat right center;

    .prize {
      @include token-paragraph-bold;

      line-height: token('font/caption/bold/line-height');
    }
  }

  &-modal {
    background: token('color/background/accent/win/win')
      url('~/assets/img/highFrequencyGame/prize-banner-large.svg') no-repeat right center;

    .prize {
      @include token-headline-h3-headline;
    }
  }
}
</style>
